export default class ImageUtils
  @size_within_width_constraint: (jq_element, width, height) ->
    if jq_element and jq_element.length
      jq_element.attr('width', width.toString() + "px")
      current_height = parseInt(jq_element.css('height').replace("px", ""))
      if current_height > height
        height_ratio = height / current_height
        jq_element.attr('width', Math.round(width * height_ratio).toString() + "px")
      return true
    return false



// WEBPACK FOOTER //
// ./app/javascript/utils/shared/image_utils.js.coffee